"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOriginDestinationPairDto = instanceOfOriginDestinationPairDto;
exports.OriginDestinationPairDtoFromJSON = OriginDestinationPairDtoFromJSON;
exports.OriginDestinationPairDtoFromJSONTyped = OriginDestinationPairDtoFromJSONTyped;
exports.OriginDestinationPairDtoToJSON = OriginDestinationPairDtoToJSON;
exports.OriginDestinationPairDtoToJSONTyped = OriginDestinationPairDtoToJSONTyped;
/**
 * Check if a given object implements the OriginDestinationPairDto interface.
 */
function instanceOfOriginDestinationPairDto(value) {
    if (!('originId' in value) || value['originId'] === undefined)
        return false;
    if (!('destinationId' in value) || value['destinationId'] === undefined)
        return false;
    return true;
}
function OriginDestinationPairDtoFromJSON(json) {
    return OriginDestinationPairDtoFromJSONTyped(json, false);
}
function OriginDestinationPairDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'originId': json['originId'],
        'destinationId': json['destinationId'],
    };
}
function OriginDestinationPairDtoToJSON(json) {
    return OriginDestinationPairDtoToJSONTyped(json, false);
}
function OriginDestinationPairDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'originId': value['originId'],
        'destinationId': value['destinationId'],
    };
}
//# sourceMappingURL=OriginDestinationPairDto.js.map